import React from "react"
import { blokType, sbAssetType, sbLinkType } from "../../types"

import { MetaDataCmp } from "./MetaData"

import SbImageService from "../../helpers/SbImageService"
import linkHandler from "../../helpers/storyblokLinkHandler"

export interface MetaDataBlokProps {
  meta_title: string
  meta_description: string
  og_title: string
  og_description: string
  og_image: sbAssetType
  og_type: string
  og_site_name: string
  twitter_card: string
  twitter_image: sbAssetType
  twitter_site: string
  favicon_set: string
  structured_data: string
  no_index: boolean
  canonical_link: sbLinkType
}

interface MetaDataWrapperProps {
  blok: MetaDataBlokProps & blokType
  path: string
}

const MetaData: React.FC<MetaDataWrapperProps> = ({ blok, path }) => (
  <>
    <MetaDataCmp
      meta_title={blok.meta_title}
      meta_description={blok.meta_description}
      og_title={blok.og_title || blok.meta_title}
      og_description={blok.og_description || blok.meta_description}
      og_image={
        blok.og_image &&
        blok.og_image.filename &&
        SbImageService(blok.og_image.filename)
      }
      og_image_alt={blok.og_description || blok.meta_description}
      og_type={blok.og_type}
      og_site_name={blok.og_site_name}
      twitter_card={blok.twitter_card}
      twitter_image={
        blok.twitter_image &&
        blok.twitter_image.filename &&
        SbImageService(blok.twitter_image.filename)
      }
      twitter_site={blok.twitter_site}
      twitter_creator={blok.twitter_site}
      og_url={process.env.GATSBY_HOST + path}
      favicon_set={blok.favicon_set}
      canonical_link={blok.canonical_link && linkHandler(blok.canonical_link)}
      structured_data={blok.structured_data}
      no_index={blok.no_index}
    />
  </>
)

export default MetaData
